import { render, staticRenderFns } from "./DTHPlans.vue?vue&type=template&id=1a16b3f3&"
import script from "./DTHPlans.vue?vue&type=script&lang=js&"
export * from "./DTHPlans.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports